import { BLANK } from 'shared_critical/constants/string';
import { abbreviateCurrency, homeEquityLoanTypes } from "shared_critical/format_helper";

MOVE.MORTGAGE.HOME_EQUITY_RATES_PAGE = (function (MORTGAGE) {
  var includeZip = true,
    $locationBoxField = $('#locationBox'),
    $providerDisclaimerContainer = $('.mrtg-rates-provider-disclaimer .disclaimer-container'),
    $rateCardContainer = $('.hel-rate-card-container'),
    $propertyPrice = $('#home-price'),
    $templatePath = 'templates/mortgage/',
    $pagination = $('#pagination'),
    rdcTracking = window.RdcTracking,
    props;

  var init = function () {
    props = {
      search: {
        provider: 'informa',
        location: null,
        loan_product: 'HELOC,HELOAN_FIXED_5YEARS,HELOAN_FIXED_10YEARS,HELOAN_FIXED_15YEARS,HELOAN_FIXED_20YEARS,HELOAN_FIXED_30YEARS',
        loan_amount: 50000,
        state: 'CA',
        limit: 50,
        property_value: 500000,
        mortgage_balance: 200000,
        zip: 94112,
        credit_score: 'excellent',
        geo_valid: false,
      },
      success: updateRatesFromHelocRequest,
      sort: 'relevance',
      pagination: {
        items: [],
        page: 1,
        perPage: MOVE.Helper.isPhone()? 6: 10,
        total: 0,
        totalPages: 0
      },
      rates: [],
      ratesToDisplay: [],
      is_mobile_app: MOVE.MORTGAGE.getQueryValue('from') === 'mobile'
    };

    MOVE.MORTGAGE.locationControlAutoCompleteSetup(
      $locationBoxField,
      MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.actions.helocLocationChanged,
      includeZip
    );
    MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.init(props);
    MOVE.MORTGAGE.RATES.SORT_VIEW.init(props);
    MOVE.MORTGAGE.RATES.PAGINATION_VIEW.init(props);
    MOVE.MORTGAGE.trackClick();
    toggleMobileAppView();
    monitorDom();
  };

  var monitorDom = function () {
    initHashLocation();
    initDOM();
    initilizeRateTable();
    initNewsTicker();
  };

  // Handle legacy params supplied as hash location
  // Assign valid options to props prior to analysis call
  var initHashLocation = function () {
    var hash = MOVE.MORTGAGE.getUrlVars();
    if (hash !== null) {
      if (hash.zip) {
        props.search.zip = hash.zip;
      }
      if (hash.property_value) {
        var propertyValue = parseInt(hash.propertyValue, 10);
        if (!isNaN(propertyValue)) {
          props.search.property_value = propertyValue;
        }
      }
      if (hash.mortgage_balance) {
        var mortgageBalance = parseInt(hash.mortgage_balance, 10);
        if (!isNaN(mortgageBalance)) {
          props.search.mortgage_balance = mortgageBalance;
        }
      }
      if (hash.loan_amount) {
        var loanAmount = parseInt(hash.loan_amount, 10);
        if (!isNaN(loanAmount)) {
          props.search.loan_amount = loanAmount;
        }
      }
    }
    MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.render();
  };

  var initDOM = function () {
    $('body').on('rates.displayCards', function() {
      props.ratesToDisplay = ratesToDisplay();
      displayCards();
    });
    return MOVE.Helper.isPhone() ? initMobileDOM() : initDesktopDOM();
  };

  var initNewsTicker = function () {
    MOVE.MultilineEllipsis.init($('.js-multiline-ellipsis'));
  };

  var initilizeRateTable = function () {
    displayLoadingSpinner();
    var location = MOVE_DATA.state_page ? MOVE_DATA.state_search_location :
    MOVE_DATA.city_page ? MOVE_DATA.city_search_location : BLANK;
    var params = {
      property_price: props.search.price,
      location: location
    };

    MOVE.MORTGAGE.RATES.REQUESTS.getAnalysis(params, function (data) {
      var search = props.search;
      search.price = data.analysis.target_price;
      search.location = data.analysis.location.location
      search.zip = data.analysis.location.zip;
      search.city = data.analysis.location.city;
      search.state = data.analysis.location.state;

      MOVE.MORTGAGE.RATES.REQUESTS.getHelocRateTable(props);
      initForm();
      searchDescription(props.search);
    });
  };

  var searchDescription = function (search) {
    var $searchCriteria = $('.search-criteria-desc');
    if ($searchCriteria.length > 0)
    {
      $searchCriteria.html('');
      var template = $templatePath + 'home_equity_rate_table_search_description';
      $searchCriteria.append(JST[template]({
        location: search.city + ", " + search.state,
        property_value: abbreviateCurrency(search.property_value),
        loan_amount: abbreviateCurrency(search.loan_amount),
        mortgage_balance: MOVE.MORTGAGE.addDollarCommas(search.mortgage_balance),
        home_equity_value: abbreviateCurrency(search.property_value - search.mortgage_balance),
        loan_types: displayLoanType(search.loan_product.split(',')),
        credit: search.credit_score === 'excellent' ? '740+' : search.credit_score
      }));
    }
  };

  var displayLoanType = function(types) {
    return homeEquityLoanTypes
      .filter((item) => types.includes(item.value))
      .map((item) => item.label)
      .join(', ')
  };

  var initForm = function () {
    $locationBoxField.val(props.search.location);
    $propertyPrice.val(MOVE.MORTGAGE.addDollarCommas(props.search.price));
  };

  var initMobileDOM = function () {
    MOVE.Common.readMore('.state-rate-header', 40);
    MOVE.MORTGAGE.RATES.SORT_VIEW.bind();
    bindSearchView();
  };

  var initDesktopDOM = function () {
    MOVE.Common.readMore('.state-rate-header', 80);
    MOVE.MORTGAGE.RATES.SORT_VIEW.bind();
    bindSearchView();
  };

  var bindSearchView = function() {
    MOVE.MORTGAGE.RATES.HELOC_SEARCH_VIEW.bind({
      searchRates: searchRates
    });
  };

  var searchRates = function () {
    displayLoadingSpinner();
    $pagination.hide();
    props.rates = [];
    props.ratesToDisplay = [];
    if (Array.isArray(props.search.loan_product)) {
      props.search.loan_product = props.search.loan_product.join(',');
    }
    props.search.property_value = MOVE.MORTGAGE.removeDollarCommas($('#home-value'));
    props.searchstate =  $('#locationBox').val().split(', ')[2];

    props.success = function (data) {
      updateRatesFromHelocRequest(data);
      displaySearchResultsForMobile();
    };
    props.error = noRatesFound;
    MOVE.MORTGAGE.RATES.REQUESTS.getHelocRateTable(props);
    searchDescription(props.search);
  };

  var updateRatesFromHelocRequest = function (data) {
    if (data.rates) {
      props.rates = data.rates
      $(props.rates).each(function (i, o) {
        o['id'] = i
      });
    } else {
      props.rates = [];
      props.primary_rates = [];
    }

    props.pagination.page = 1; // Reset to first page
    props.ratesToDisplay = ratesToDisplay();
    props.selectedRate = [];
    getDisclaimerInfo(data);
    displayAdvertisingDisclosure();
    displayCards();
    bindRateCardDetailModal();
  };

  var noRatesFound = function () {
    updateRatesFromHelocRequest({full_rates: null});
  };

  var getDisclaimerInfo = function(result) {
    props.provider = result.disclosures;
  }

  var ratesToDisplay = function () {
    var rates = _.clone(props.rates);
    // Sort
    if (rates.length > 0) {
      rates = MOVE.MORTGAGE.RATES.SORT.sortHomeEquityByType(rates, props.sort);
    }
    // Paginate
    var pagination = MOVE.MORTGAGE.RATES.PAGINATION.getPage(rates, props.pagination.page, props.pagination.perPage);
    props.pagination = pagination;
    return props.pagination.items;
  };

  var goPageTop = function () {
    return $rateCardContainer.find('.mrtg-rate-card').length === 0
  };

  var displayCards = function () {
    var goTop = goPageTop();
    $rateCardContainer.empty();
    if (props.ratesToDisplay.length === 0) {
      $('.advertising-disclosure').addClass('hide');
      $('.mrtg-rates-provider-disclaimer').addClass('hide');
      MOVE.MORTGAGE.RATES.MESSAGE_VIEW.homeEquityInit(props);
    } else {
      $('.advertising-disclosure').removeClass('hide');
      $('.mrtg-rates-provider-disclaimer').removeClass('hide');
      displayProviderDisclaimer();
      openHelocDisclosureFromDesktopLink();
      openHelocDisclosureFromLink();
      renderRates();
    }
    MOVE.MORTGAGE.RATES.PAGINATION_VIEW.render();
    scrollToTopCard(goTop);
    trackPageView(props);
    MOVE.MORTGAGE.trackClick($rateCardContainer);
  };

  var bindRateCardDetailModal = function(index) {
    hideModal(index);
    hideModalBackdrop();

    $(`.link-rate-detail-${index}`).on('click', function() {
      toggleModal(index);
      showModalBackdrop();
      $('body').css('overflow', 'hidden');
    });

    $(`.hel-rate-card-modal-close-${index}, .hel-modal-close, .hel-rate-card-modal-backdrop`).on('click', function() {
      hideModal(index);
      hideModalBackdrop();
      $('body').css('overflow', 'auto');
    });
  }

  var hideModalBackdrop = function() {
    $('.hel-rate-card-modal-backdrop').hide();
  }

  var showModalBackdrop = function() {
    $('.hel-rate-card-modal-backdrop').show();
  }

  var toggleModal = function(index) {
    $(`.hel-rate-card-modal-${index}`).toggle('slide');
  }

  var hideModal = function(index) {
    $(`.hel-rate-card-modal-${index}`).hide();
  }

  var renderRates = function() {
    _.each(props.ratesToDisplay, function (rate, i) {
      var template = $templatePath + cardTemplate();
      $rateCardContainer.append(JST[template]({
        rate: rate,
        rateAsJSON: JSON.stringify(rate).replace(/"/g, "'"),
        index: i,
        loanAmount: MOVE.MORTGAGE.addDollarCommas(props.search.loan_amount),
        minDraw: rate.MinDraw? MOVE.MORTGAGE.addDollarCommas(rate.MinDraw): '',
        loanType: loanTypeLongForm(rate.LoanType, rate.LoanTerm)
      }));
      bindRateCardDetailModal(i);
    });
  }

  var loanTypeLongForm = function(loanType, termInMonths) {
    if (loanType === "HELOC") {
      return "Home Equity Line of Credit";
    } else if (termInMonths) {
      return "Home Equity Loan - " + termInMonths/12 + " Years";
    } else {
      return "Home Equity Loan"
    }
  }

  var trackPageView = function(props) {
    var pageName = 'finance:rate_table_heloc';
    var iid = MOVE.MORTGAGE.getQueryValue('iid');
    var pageData = {
      siteSection: 'finance',
      pageType: 'finance',
      searchPage: props.pagination.page,
      searchResultCount: props.pagination.total,
      city: props.search.city,
      creditScore: props.search.credit_score,
      loanAmount: props.search.loan_amount,
      loanProduct: props.search.loan_product,
      location: props.search.location,
      mortgageBalance: props.search.mortgage_balance,
      propertyValue: props.search.property_value,
      provider: props.search.provider,
      state: props.search.state,
      iid: iid !=="" ? iid : null,
      zip: props.search.zip
    };

    if (props.rates.length === 0) {
      pageName += '_no_results';
    }

    rdcTracking.trackPage(pageName, pageData);
  }

  var cardTemplate = function () {
    return (MOVE.Helper.isPhone()) ?
      'home_equity_rate_table_card_mobile' :
      'home_equity_rate_table_card';
  };

  var displaySearchResultsForMobile = function () {
    if (!MOVE.Helper.isMobileDevice()) return;
    $('.js-hel-rates-search-mobile').slideUp('fast', function () {
      $('.js-hel-rate-table-mobile').slideDown('fast', function () {
        displayAdvertisingDisclosure();
        scrollToTopCard();
      });
    });
  };

  var displayAdvertisingDisclosure = function () {
    $('.js-advertising-disclosure').show();
  };

  var scrollToTopCard = function (goTop) {
    var position = 0;
    if (!goTop) {
      if (MOVE.Helper.isPhone()) {
        position = $('.js-hel-rate-table-mobile').offset().top;
      } else {
        position = getHelocRateTableOffset();
      }
    }
    $('html, body').animate({scrollTop: position}, 600);
  };

  var getHelocRateTableOffset = function(){
    var statePage = $('.state-mrtg-rates-header').length > 0,
        cityPage = $('.city-mrtg-rates-header').length > 0,
        loanTypePage = $('.product-mrtg-rates-header').length > 0,
        offset = 0;

    if (statePage) {
      offset = $('.js-state-header').offset().top;
    }else if (loanTypePage) {
      offset = $('.js-product-header').offset().top;
    }else if (cityPage) {
      offset = $('.js-city-header').offset().top;
    }
    else {
      offset = $('.js-mrtg-rates-header').offset().top;
    }
    return offset;
  }

  var displayLoadingSpinner = function () {
    var content =
      '<div id="rates-loading-spinner" class="loading-graphic"></div>';
    $rateCardContainer.html(content);
  };

  var displayProviderDisclaimer = function () {
    $providerDisclaimerContainer.empty();
    var template = $templatePath + 'rate_table_provider_disclaimer';
    $providerDisclaimerContainer.append(JST[template]({
      provider: props.provider,
    }));

    $('.mrtg-rates-provider-disclaimer').removeClass('hide');
  };

  var toggleMobileAppView = function () {
    if (props.is_mobile_app) {
      hideNonHelocRateTableStuff();
    } else {
      showNonHelocRateTableStuff();
    }
  };

  var hideNonHelocRateTableStuff = function () {
    $('#header-navbar').addClass('hide');
    $('#footer').addClass('hide');
    $('.js-rate-table-ad ').addClass('hide');
  };

  var showNonHelocRateTableStuff = function () {
    $('#header-navbar').removeClass('hide');
    $('#footer').removeClass('hide');
    $('#bottomSection').removeClass('hide');
    $('.js-rate-table-ad ').removeClass('hide');
  };

  // Scroll from Ad Disclosure desktop link
  var openHelocDisclosureFromDesktopLink = function () {
    $('.advertising-disclosure.desktop').on('click', function () {
      var disclosurePos = $('.mrtg-rates-provider-disclaimer').offset().top;
      $('html, body').animate({scrollTop: disclosurePos - 280}, 600);
    })
  };

  // Expand disclosure details when user clicks on Ad Disclosure link
  var openHelocDisclosureFromLink = function () {
    $('.advertising-disclosure').on('click', function () {
      if (!$('#collapse-rate-disclaimer').hasClass('collapse in')) {
        $('#collapse-rate-disclaimer').collapse('show');
        $('.toggle-rate-disclaimer .arrow-toggle').removeClass('ra-angle-down').addClass('ra-angle-up');
      }
    })
  };

  MORTGAGE.HOME_EQUITY_RATES_PAGE = {
    init: init
  };
  return MORTGAGE.HOME_EQUITY_RATES_PAGE;

})(MOVE.MORTGAGE || {});



// WEBPACK FOOTER //
// ./mortgage/rates/home_equity_rate_page.js